<template>
  <v-container
      fill-height
      fluid
      grid-list-xl
  >
    <v-layout
        justify-center
        wrap
    >
      <v-flex
          md12
      >
        <div>
          <card>
            <v-spacer/>
            <v-dialog
                v-model="dialog"
                persistent
                max-width="768px">
              <template v-slot:activator="{ on }">
                <v-layout>
                  <v-flex
                      xs9
                      sm9
                      md9>
                    <base-input
                        v-model="search"
                        :loading="loading"
                        label="Search"
                        placeholder="Search..."
                        hide-details
                        @keyup.enter="index"/>
                  </v-flex>
                  <v-flex
                      xs3
                      sm3
                      md3>
                    <base-button
                        class="float-right"
                        @click="index">
                      Refresh
                    </base-button>
                  </v-flex>
                </v-layout>
              </template>
              <card :title="'Edit ' + editedItem.name">
                <a :href="getStripeLink()" target="_blank">{{getStripeLink()}}</a>
                <v-container grid-list-md >
                  <v-layout wrap>
                    <v-flex
                        xs12
                        sm12
                        md12>
                      <base-input
                          v-model="editedItem.id"
                          :disabled="true"
                          required
                          label="Id"
                      />
                    </v-flex>
                    <v-flex
                        xs12
                        sm12
                        md12>
                      <base-input
                          v-model="editedItem.name"
                          required
                          label="Name" />
                    </v-flex>
                    <v-flex
                        xs12
                        sm12
                        md12>
                      <base-input
                          v-model="editedItem.email"
                          required
                          label="Email" />
                    </v-flex>
                    <v-flex
                        xs12
                        sm12
                        md12>
                      <base-checkbox
                          :checked="editedItem.verified"
                          style="display: inline"
                          required
                          label="Verified"
                          @input="editVerified" >
                        Verified
                      </base-checkbox>
                    </v-flex>
                    <v-flex
                        xs12
                        sm12
                        md12>
                      <base-input
                          v-model="editedItem.card_last_four"
                          required
                          label="Card" />
                    </v-flex>
                  </v-layout>
                </v-container>

                <v-card-actions>
                  <base-button
                      @click="close">Cancel</base-button>

                  <v-spacer/>
                  <base-button
                      type="primary"
                      @click="save">Save</base-button>
                </v-card-actions>
              </card>
            </v-dialog>
            <v-data-table
                :headers="headers"
                :items="UserList"
                :pagination.sync="pagination"
                :total-items="totalUsers"
                :loading="loading"
                :light="false"
                class="table table-striped"
            >

              <!-- change table header background and text color(or other properties) -->
              <template
                  slot="headerCell"
                  slot-scope="{ header }"
              >
                <span
                    class="subheading font-weight-light text-general text--darken-3"
                    v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <tr @click="editItem(props.item)">
                  <td>
                    {{ props.item.id }}
                  </td>

                  <td>
                    {{ props.item.name }}
                  </td>
                  <td>
                    {{ props.item.email }}
                  </td>
                  <td>
                    <v-icon v-if="props.item.verified">check</v-icon>
                  </td>
                  <td>
                    {{ props.item.card_last_four }}
                  </td>
                  <td>
                    {{ props.item.created_at || moment("from")}}
                  </td>
                </tr>
              </template>
            </v-data-table>
            <v-snackbar
                v-model="snack"
                :timeout="5000"
                :color="snackColor">
              {{ snackText }}
              <v-btn
                  flat
                  @click="snack = false">Close</v-btn>
            </v-snackbar>
          </card>
        </div>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import BaseButton from '@/components/BaseButton'

export default {
  components: { BaseButton },
  data: () => ({
    snack: false,
    snackColor: '',
    snackText: '',
    pagination: {
      rowsPerPage: 10,
      sortBy: 'created_at',
      descending: 'true'
    },
    UserList: [

    ],
    totalUsers: 0,
    loading: true,

    startCalendar: false,
    endCalendar: false,

    checkboxAdmin: true,
    checkboxActive: true,
    rowsAmount: [10, 20, 50, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }],
    dialog: false,

    search: '',
    headers: [
      {
        text: 'ID',
        value: 'id'
      },
      {
        text: 'Name',
        value: 'name'
      },
      {
        text: 'Email',
        value: 'email'
      },
      {
        text: 'Verified',
        value: 'verified'
      },
      {
        text: 'Card Last Four',
        value: 'card_last_four'
      },
      {
        text: 'Member Since',
        value: 'created_at'
      },
    ],
    editedIndex: -1,
    editedItem: {
      id: '',
      name: '',
      email: '',
      stripe_id: '',
      verified: false,
      card_last_four: '',
      created_at: '',
    },
    defaultItem: {
      id: '',
      name: '',
      email: '',
      stripe_id: '',
      verified: false,
      card_last_four: '',
      created_at: '',
    }
  }),

  computed: {
    ...mapState('app', ['color']),
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    pagination: {
      handler () {
        this.index()
      },
      deep: true
    }
  },

  methods: {
    index () {
      this.$store.state.spinning = true
      this.loading = true
      const params = new URLSearchParams(this.pagination)

      params.append('search', this.search)
      let self = this
      axios.get('/users?' + params.toString())
          .then(response => {
            self.UserList = response.data.data
            self.totalUsers = response.data.total
            self.$store.state.spinning = false
            self.loading = false
          })
          .catch(err => {
            if (err.response.status == '403') {
              this.showError('Unauthorized')
            } else {
              this.showError(JSON.stringify(err.response.data.errors))
            }
            self.$store.state.spinning = false
            self.loading = false
            console.log(err.response.data.errors)
          })
    },

    getStripeLink() {
      if (this.editedItem.stripe_id == null || this.editedItem.stripe_id === "") {
        return ""
      }
      return "https://dashboard.stripe.com/test/customers/" + this.editedItem.stripe_id
    },

    // object.assign fills in the empty object with the properties of item
    editItem (item, dbox = true) {
      this.editedIndex = this.UserList.indexOf(item)
      this.editedItem = {
        id: item.id,
        name: item.name,
        email: item.email,
        stripe_id: item.stripe_id,
        verified: item.verified,
        card_last_four: item.card_last_four,
        created_at: item.created_at,
      }
      this.dialog = dbox
    },

    editVerified (verified) {
      this.editedItem.verified = verified
    },
    callTableAction (item, endpoint, method) {
      let tableItem = this.editedItem
      this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
          .then((response) => this.saveInline())
          .catch(error => {
            console.log(error)
            this.cancelInline
          })
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      // update
      if (this.editedIndex !== -1) {
        this.$store.state.spinning = true
        axios.put('/users/' + this.editedItem.id, this.editedItem)
            .then((response) => {
                  // Object.assign(this.UserList[this.editedIndex], response.data)
                  this.index()
                  this.saveInline()
                  this.close()
                  this.$store.state.spinning = false
                }
            )
            .catch(error => {
              if (error.response && error.response.status == '422') {
                this.showError(JSON.stringify(error.response.data.errors))
              } else {
                this.showError(error.response.data)
              }
              console.log(error)
              this.cancelInline
              this.$store.state.spinning = false
            })
      }
    }, // toasts/snackbar messages for actions
    saveInline () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'User saved'
    },
    deleteInline () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'User deleted'
    },
    showError (errorMessage) {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = errorMessage || 'Something went wrong, try again later!'
    },
    cancelInline () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Canceled'
    },
    reset () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Data reset to default'
    },
    openInline () {
      this.snack = true
      this.snackColor = 'info'
      this.snackText = 'Dialog opened'
    },
    closeInline () {
      console.log('Dialog closed')
    }
  }
}
</script>

<style>
table.v-table thead tr {
  color: red !important;
}
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, .05);
}
</style>
